@if (!(isLoading$ | async)) {
    <div class="edit-form__wrapper grid grid-cols-1 divide-y bg-white">
      <div class="hidden"></div>
      <app-edit-company-details
        [companyDetails]="companyDetails"
      ></app-edit-company-details>
      <app-edit-bank-details
        [bankDetails]="bankDetails"
      ></app-edit-bank-details>
      <app-edit-director-details
        [directorDetails]="directorDetails"
      ></app-edit-director-details>
      <app-edit-signatory-details
        [signatoriesList]="signatoriesList"
      ></app-edit-signatory-details>
      <app-edit-documents [kycDocuments]="documents"></app-edit-documents>
      <div></div>
    </div>
} @else {
  <div class="flex flex-col">
    <ngx-skeleton-loader
      *ngFor="let in of [0, 1, 2, 3, 4, 5, 6]; let i = index"
      [theme]="{ height: '5rem', width: '100%' }"
    ></ngx-skeleton-loader>
  </div>
}
